<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Fecha</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="validateDates" size="sm" id="init"
                  v-model="filter_init" :max="today" />
              </CCol>
              <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" @input="validateDates" id="end" size="sm"
                  v-model="filter_end" :max="today" />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Reporte de Encargados por Citas" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'"
          :myButtons="myButtons" :withActions="'2%'" :actions="true" @mtdViewDetalleQuote="mtdViewDetalleQuote">
        </CTableWrapper>
      </CCol>
    </CRow>
    <cModalReportQuoteVue :title="modalReportQuote.title" :boo_modal="modalReportQuote.modal_form"
      :item="modalReportQuote.item" :name_barber="modalReportQuote.name_barber" :barber_id="Number(modalReportQuote.barber_id)"
      @closeModalReportQuote="closeModalReportQuote" />
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Personal", _style: "width:10%;" },
  { key: "cantidad", label: "Cantidad de Citas", _style: "width:10%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";
import cModalReportQuoteVue from "./modals/cModalReportQuote.vue";
export default {
  components: {
    CTableWrapper,
    cModalReportQuoteVue,
  },
  data() {
    return {
      prefix: "report",
      fields,
      data: [],
      filter_init: null,
      filter_end: null,
      componentKey: 0,
      today: moment().format("YYYY-MM-DD"),
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "cita",
          action: "mtdViewDetalleQuote",
          icon: "far fa-folder",
        },
      ],
      modalReportQuote: {
        title: "VER DETALLE DE CITAS",
        modal_form: false,
        item: [],
        name_barber: "",
        barber_id:"",
      },
    };
  },
  created() {
    moment.locale("es");
    this.filter_init = this.today;
    this.filter_end = this.today;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    validateDates() {
      // No permitir fechas futuras
      if (this.filter_init > this.today) {
        this.filter_init = this.today;
      }
      if (this.filter_end > this.today) {
        this.filter_end = this.today;
      }

      // Valido rangos incorrectos
      if (this.filter_end < this.filter_init) {
        this.filter_init = this.filter_end;
      }
      if (this.filter_init > this.filter_end) {
        this.filter_end = this.filter_init;
      }
      this.mtd_data();
    },
    mtd_data: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byEncargadosxQuote",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter_init,
          end: this.filter_end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            const barbers = response.data.user;
            const quotes = response.data.data;

            const userCounts = {};
            // Recorremos los quotes y extraemos los user_id de los barberos
            quotes.forEach(quote => {
              quote.barber_detail.forEach(barberDetail => {
                if (barberDetail.barber && barberDetail.barber.user_id) {
                  const userId = barberDetail.barber.user_id;
                  if (!userCounts[userId]) {
                    userCounts[userId] = {
                      cantidad: 0,
                      quotes: [],
                    };
                  }
                  // Incrementamos la cantidad y agregamos el quote
                  userCounts[userId].cantidad++;
                  userCounts[userId].quotes.push(quote);
                }
              });
            });

            // Asignamos la cantidad de veces que aparece cada usuario a this.data
            this.data = barbers.map((barber, index) => {
              const userData = userCounts[barber.user_id] || { cantidad: 0, quotes: [], barber_detail: [] };
              return {
                id: barber.id,
                name: `${barber.name} ${barber.last_name}`,
                cantidad: userData.cantidad,
                quotes: userData.quotes, 
                index: index + 1,
              };
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    closeModalReportQuote: function () {
      this.modalReportQuote.modal_form = false;
    },
    mtdViewDetalleQuote(item) {
      this.modalReportQuote.modal_form = true;
      this.modalReportQuote.item = item.quotes;
      this.modalReportQuote.name_barber = item.name;
      this.modalReportQuote.barber_id = item.id;
    }
  },

};
</script>

<style lang="scss" scoped></style>